<template>
  <div data-v-6dfc2180="" data-v-e5781868="" class="bottomBar">
    <div data-v-6dfc2180="" class="content">
      <div data-v-6dfc2180="" class="sponsors">
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/AG.ec04d38b.png" alt="" class="sponsor1" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/bbin.7da755c0.png" alt="" class="sponsor2" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/MGS.709db304.png" alt="" class="sponsor3" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/saba.d80d7324.png" alt="" class="sponsor4" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/top.48a0277b.png" alt="" class="sponsor5" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/Playtech.ef31edc6.png" alt="" class="sponsor6" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/playstarm.cc5990ca.png" alt="" class="sponsor7" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/ebet.3339ecf0.png" alt="" class="sponsor8" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/PNG.34321c77.png" alt="" class="sponsor9" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/PP.e7e0199f.png" alt="" class="sponsor10" /></div>
        <div data-v-6dfc2180="" class="item"><img data-v-6dfc2180="" src="/static/image/AS.61700785.png" alt="" class="sponsor11" /></div>
      </div>
      <div data-v-6dfc2180="" class="info"><img data-v-6dfc2180="" src="/static/image/pagcor.dd25993d.png" alt="" />{{$store.state.appInfo.title}}拥有菲律宾政府竞猜委员会（PAGCOR）颁发的合法执照。是受国际行业协会认可的合法公司。进行注册并娱乐前，请确保您年满18周岁</div>
      <div data-v-6dfc2180="" class="bottomLinks">
        <a data-v-6dfc2180="" href="javascript:void(0);" @click="goNav('/aboutUS')">关于我们</a>
        <a data-v-6dfc2180="" href="javascript:void(0);" @click="goNav('/guides')" >新手学堂</a>
        <a data-v-6dfc2180="" href="javascript:void(0);" @click="goNav('/depositWays')" >充值方式</a>
        <a data-v-6dfc2180="" href="javascript:void(0);" @click="goNav('/gameRules')">游戏介绍</a>
      </div>
      <div data-v-6dfc2180="" class="copyright">
        <p data-v-6dfc2180="">版权所有©️2022{{$store.state.appInfo.title}}娱乐保留所有</p>
      </div>
      <div data-v-6dfc2180="" class="clearfix" style="display: none">
        <div data-v-80666edc="" data-v-6dfc2180="" class="ysb-side-button"><img data-v-80666edc="" src="/static/image/ysb-express-btn2.22699f95.png" alt="" class="ysb-entrance-button" /></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Foot',
  data() {
    return {};
  },
  methods: {
    goNav(url) {
      let that = this;
      // let urlStr = url.split('?')[0];
      if (url == this.$route.fullPath) {
        that.$parent.showTost('您就在当前页');
        return;
      }
      this.url = url;
      this.$router.push({ path: url });
    },
    open(url) {
      window.open(url);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
// foot 样式 <link rel="stylesheet" type="text/css" href="css/chunk-611499bd.2ebefcf0.css">

// @import url();
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue